import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import VideoModal from '../../components/AdminPortal/Videos/VideoModal';
import VideoRow from '../../components/AdminPortal/Videos/VideoRow';
import { useGetVideosQuery } from '../../features/videos/videosApi';
import { endEditing } from '../../features/videos/videosSlice';

const Videos = () => {
    const [opened, setOpened] = useState(false);
    const dispatch = useDispatch();

    const controlModal = () => {
        setOpened((prevState) => !prevState);
    };

    const {data:videos, isLoading, isError} = useGetVideosQuery();

  let content;

  if (isLoading) {
    content = <div>Loading...</div>;
  }
  if (!isLoading && isError) {
    content = <div>Something went wrong</div>;
  }
  if (!isLoading && !isError && videos.length === 0) {
    content = <div>No video available</div>;
  }
  if (!isLoading && !isError && videos.length > 0) {
    content = videos.map((video) => <VideoRow key={video.id} video={video} open={opened} control={controlModal}/>);
  }
    return (
        <section className="py-6 bg-primary">
        <div className="mx-auto max-w-full px-5 lg:px-20 relative"> 
        
          <div className="px-3 py-20 bg-opacity-10">
          
            <div className="w-full flex ">
             {!opened &&  <button className="btn ml-auto" onClick={controlModal}>Add Video</button>}
            </div>
           <VideoModal open={opened} control={controlModal}/>
            <div className="overflow-x-auto mt-4">
            
            <table className="divide-y-1 text-base divide-gray-600 w-full">
                        <thead>
                            <tr>
                                <th className="table-th">Video Title</th>
                                <th className="table-th">Description</th>
                                <th className="table-th">Action</th>
                            </tr>
                        </thead>

                        <tbody className="divide-y divide-slate-600/50">
                           {content}
                        </tbody>
                    </table>
            </div>
          </div>
        </div>
  
       
      </section>
    );
};

export default Videos;